import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import scraperService from '@/services/scraper.service';

export const fetchSources = createAsyncThunk('scraper/fetchSources', async (params, { rejectWithValue }) => {
  try {
    return await scraperService.sources(params);
  } catch (err) {
    return rejectWithValue(err);
  }
});

const scraperSlice = createSlice({
  name: 'scraper',
  initialState: { items: [], counts: { runnable: 0, needsConfig: 0, total: 0 }, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSources.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSources.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.items = payload.data || [];
        state.counts = payload.counts || state.counts;
      })
      .addCase(fetchSources.rejected, (state, { payload, error }) => {
        state.loading = false;
        state.error = payload || { message: error.message };
      });
  },
});

export default scraperSlice.reducer;
